export const NOTIFICATION_READ_EVENT = "nia-notification-read";

export const notificationReadStorageKey = (uid, orgId) =>
  `nia_notif_read__${uid || "anon"}__${orgId || "org_default"}`;

function readNotificationStorage(readKey) {
  if (!readKey) return [];
  const stores = [];
  try {
    if (typeof window !== "undefined" && window.localStorage) stores.push(window.localStorage);
  } catch {}
  try {
    if (typeof window !== "undefined" && window.sessionStorage) stores.push(window.sessionStorage);
  } catch {}
  for (const store of stores) {
    try {
      const raw = JSON.parse(store.getItem(readKey) || "[]");
      if (Array.isArray(raw)) return raw;
    } catch {}
  }
  return [];
}

export const getReadNotificationIds = (readKey) => {
  try {
    const raw = readNotificationStorage(readKey);
    if (!Array.isArray(raw)) return new Set();
    return new Set(raw.filter(Boolean).map((v) => String(v)));
  } catch {
    return new Set();
  }
};

export const resolveNotificationRoute = (row) => {
  const id = row?.sessionId || row?.session_id;
  if (id) return `/chat?id=${id}`;
  return "/notifications";
};

export const markNotificationRead = (readKey, row) => {
  const id = String(row?.id || "").trim();
  if (!id) return;
  try {
    const set = getReadNotificationIds(readKey);
    set.add(id);
    const next = JSON.stringify(Array.from(set));
    if (typeof window !== "undefined" && window.localStorage) {
      window.localStorage.setItem(readKey, next);
    }
    if (typeof window !== "undefined" && window.sessionStorage) {
      window.sessionStorage.setItem(readKey, next);
    }
    window.dispatchEvent(new CustomEvent(NOTIFICATION_READ_EVENT, { detail: { readKey, id } }));
  } catch {}
};

export const dismissNotification = (readKey, row) => {
  markNotificationRead(readKey, row);
};

export const handleNotificationTap = ({ navigate, row, readKey, currentPathname }) => {
  markNotificationRead(readKey, row);
  const destination = resolveNotificationRoute(row) || "/notifications";
  if (currentPathname === destination) {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    return destination;
  }
  navigate(destination, { state: { notifTapAt: Date.now() } });
  return destination;
};
